import { inactiveIntervals } from './inactiveIntervals';
import { TimeInterval } from './timers';
export const calculateIntervals = <TMetadata>({
  interval,
  metadata,
}: {
  interval: TimeInterval;
  metadata: TMetadata;
}) => {
  const overall = interval[1] - interval[0];
  const active = overall - inactiveIntervals.getTotalInactiveTimeIn(interval);

  return { overall, active, metadata: metadata as TMetadata | undefined };
};
